import React, { useState, useRef } from 'react'
import { AvForm, AvField } from "availity-reactstrap-validation";
import {Col, Row, UncontrolledAlert, Spinner } from "reactstrap";
import api from 'API/Api';
import { Link } from 'react-router-dom';

const AddCanType = () => {
    const  formRef  = useRef(null);

    const [ submitted, setSumbitted ] = useState(false);
    const [ loading, setLoading ] = useState(false)

    const handleValidSubmit = async (event, values) => {
      setLoading(true);
      try {
        const response = await api.post('create-can-type', values);
        if(response.data.success === true){
          formRef.current.reset();
          setSumbitted(true);
        }
      } catch (error) {
        // Handled by global interceptor
      }
      setLoading(false)
    } 
  return (
         <>
           <div className='dashBody'>
    <div className="font-size-18 mb-0 dashHeader">
          <Row>
      <Col md={6}>
      <h4>Add Can Type</h4>
      </Col>
      <Col md={6} style={{textAlign:'right'}}>
      <Link  to='/can-types'  className='dashBtn'    >
            <i className=" fas fa-chevron-left "></i> <b> Back</b>
                        </Link>
      </Col>
    </Row>  
   </div>
   <div className='dashContent'>
              <AvForm
                      style={{position:'relative'}}
                      ref={formRef}
                      className="form-horizontal"
                      onValidSubmit={(e, v) => {
                        handleValidSubmit(e, v)
                      }}
                    >
                      <div className="mb-3">
                        <AvField
                          name="canName"
                          label="Can Type Name"
                          value=""
                          className="form-control"
                          placeholder="Enter Can Type Name"
                          type="text"
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <AvField
                          name="weight"
                          label="Can Type Weight"
                          value=""
                          className="form-control"
                          placeholder="Enter Can Type Weight"
                          type="text"
                          required
                        />
                      </div>
                     

                      <div className="mb-3 row mt-4">
                        <div className="col-6">
                        { submitted ? (  <UncontrolledAlert color="success">
                            <strong>Can Type is Added!</strong>
                        </UncontrolledAlert> ) : null }
                        </div>
                        <div className="col-6 text-end">
                          <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                          { loading ? (<><Spinner animation="border" size="sm" /><span style={{paddingLeft:'10px'}}>Adding...</span></>)  : (<span>Add Can Type </span>)}
                              </button>
                        </div>
                      </div>
                    </AvForm>
                    </div>
                    </div>
         </>
  )
}

export default AddCanType